import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PaymentTerm, PaymentTermCreate, PaymentTermFilter } from '../data/paymentTerm';

export function createPaymentTermService(client: AxiosInstance) {
  return createCrudService<PaymentTerm, PaymentTermCreate, PaymentTermFilter>(
    client,
    '/master-data/PaymentTerm',
    'id',
  );
}

export type PaymentTermService = CrudService<PaymentTerm, PaymentTermCreate, PaymentTermFilter>;
